/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-26T09:20:14.881
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHousePutawayEditInit,
	getRentHousePutawayView
} from '@api/rentmanage/RentHousePutaway';

import {
listRentHousePutawayItemInit,
listRentHousePutawayItemByAuthorizations,
deleteRentHousePutawayItem
} from '@api/rentmanage/RentHousePutawayItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHousePutawayEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHousePutawayEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHousePutawayView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHousePutawayView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
